module.exports = __webpack_public_path__ + "8e768ab02fe2258ff1da99c161d4dbb7.jpg";